import { ApiClient } from '@solar/api-client';

export const api = new ApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  onUnauthorized: () => {
    window.dispatchEvent(new CustomEvent('solar:unauthorized'));
  },
});
